<template>
  <div class="demo-inline-spacing">
    <b-form-radio
      v-for="item in dictOptions"
      :key="item.value"
      v-model="data"
      class="mt-1"
      :name="parentID"
      :value="item.value"
      :disabled="disabled"
    >
      {{ item.label }}
    </b-form-radio>
  </div>
</template>

<script>
import { BFormRadio } from 'bootstrap-vue'
import { getDicts } from '../utils'

export default {
  components: {
    BFormRadio,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
      dictOptions: [],
      dictCode: this.option.dictCode || this.option.dictBizCode,
      parentID: this.name || '',
      updateNow: this.option.updateNow || false,
    }
  },
  computed: {

  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        this.initDictOption(e)
      },
      deep: true,
      immediate: true,
    },
    'option.dictData': {
      handler(e) {
        if (e) {
          if (e.length > 0) {
            this.dictOptions = e
          }
        }
      },
      immediate: true,
    },
    'option.dictBizCode': {
      handler(e) {
        if (e && this.updateNow) {
          this.dictCode = e
          this.changeDictOption()
        }
      },
      deep: true,
      immediate: true,
    },
    'option.dictCode': {
      handler(e) {
        if (e && this.updateNow) {
          this.dictCode = e
          this.changeDictOption()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    if (!this.name) {
      this.parentID = String(Math.random())
    }
  },
  methods: {
    initDictOption(e) {
      if (this.dictCode && this.dictOptions.length <= 0) {
        getDicts(this.option).then(res => {
          this.dictOptions = res
        })
      }
      this.data = e
    },
    changeDictOption() {
      getDicts(this.option).then(res => {
        this.dictOptions = res
      })
    },
  },
}

</script>

<style lang='scss' scoped>

</style>
